<div class="slides">
    <app-scroll #scroll class="scroll">
        @for (slide of slides; track slide) {
        <div
            (click)="handleClick(slide)"
            [class.slide--active]="slide === activeResource"
            [appScrollIntoView]="slide === activeResource"
            class="slide"
        >
            <div class="slide__outer">
                <div class="slide__inner">
                    <app-screen
                        class="slide__screen"
                        [resource]="slide"
                        [autoload]="true"
                    ></app-screen>
                </div>
            </div>
            <app-resource-toggle [resource]="slide"></app-resource-toggle>
        </div>
        }
    </app-scroll>

    <app-scroll-indicator [scroll]="scroll"></app-scroll-indicator>
</div>

@if (showBack) {
<div class="button back" (click)="back()">
    <i class="fas fa-arrow-alt-left"></i>
</div>
} @if (showNext) {
<div class="button forward" (click)="next()">
    <i class="fas fa-arrow-alt-right"></i>
</div>
}

<div class="action-buttons">
    <app-button
        class="outset-with-icon outset-with-icon--big"
        (click)="print()"
    >
        <i class="fas fa-print"></i>
    </app-button>
</div>
